import {Divider, Stack} from "@mui/material";
import {Day} from "../../Day";
import {TaskEvent} from "@core/model/Task";
import {EventTime} from "./EventTime";
import React from "react";
const AgendaRow = ({
  day,
  minimize = false,
  grouped,
  first = false,
  last = false,
}: {
  minimize?: boolean;
  day: string;
  grouped: {[key: string]: TaskEvent[]};
  first?: boolean;
  last?: boolean;
}) => {
  return (
    <>
      <Stack className="agenda-row" direction={"row"}>
        <Day
          sx={{borderRadius: first ? "8px 0 0 0" : last ? "0 0 0 8px" : 0}}
          date={new Date(Number(day))}
          view={"agenda"}
          minimize={minimize}
        />
        <Stack
          flex={1}
          minWidth={0}
          bgcolor="background.paper"
          sx={{
            borderRadius: first ? "0 8px 0 0" : last ? "0 0 8px 0" : 0,
          }}>
          {grouped[Number(day)].map((event, eventIndex) => (
            <React.Fragment key={`agenda-event-${eventIndex}`}>
              <EventTime event={event} minimize={minimize} />
              {grouped[Number(day)].length > 1 && <Divider />}
            </React.Fragment>
          ))}
        </Stack>
      </Stack>
    </>
  );
};

export {AgendaRow};
